import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectCanUploadMeetingNotes } from '@store/selectors/user/user.selectors';

@Component({
  selector: 'app-meeting-notes-actions-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="actions-container">
      <button *ngIf="isPdf" class="actionButton" id="viewButton" mat-mini-fab data-action="view" title="View">
        <mat-icon data-action="view">visibility</mat-icon>
      </button>
      <button class="actionButton" id="downloadButton" mat-mini-fab data-action="download" title="Download">
        <mat-icon data-action="download">download</mat-icon>
      </button>
      <button *ngIf="canUpload" class="actionButton" id="deleteButton" mat-mini-fab data-action="delete" title="Delete">
        <mat-icon data-action="delete">delete</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .actionButton {
      margin: 2px;
      cursor: pointer;
    }
    #viewButton, #downloadButton {
      background-color: #0099ab;
      color: white;
    }
    #deleteButton {
      background-color: red;
      color: white;
    }
  `]
})
export class MeetingNotesActionsRendererComponent implements ICellRendererAngularComp, OnDestroy {
  private readonly store = inject(Store);
  private readonly destroy$ = new Subject<void>();

  canUpload = false;
  isPdf = true;

  agInit(params: ICellRendererParams): void {
    const fileName: string = params.data?.fileName ?? '';
    const ext = fileName.split('.').pop()?.toLowerCase();
    this.isPdf = ext === 'pdf';

    this.store.select(selectCanUploadMeetingNotes)
      .pipe(takeUntil(this.destroy$))
      .subscribe(can => { this.canUpload = can; });
  }

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
